import { EntryType } from '@morph-mapper/types';

export const suggestionTypeFor = (entryType: EntryType): EntryType =>
  entryType === EntryType.Simple ? EntryType.Simple : EntryType.Code;
